import { FC } from 'react'
import { Dialog, LoadingButton } from '../atoms'
import Button from '@mui/material/Button'
import { RPUser } from '@hazadapt-git/public-core-base'
import { NewRPUser, ProfileFormMode } from '../../lib/entities'
import { ProfileDetailsForm } from './ProfileDetailsForm'
import { useFormikStateSync } from '../../lib/hooks/useFormikStateSync'

interface AddTeamMemberModalProps {
    activeUser: RPUser
    // Dialog props
    open?: boolean
    onClose(): void
    onSubmit(newUser: NewRPUser): Promise<void> | void
}

export const AddTeamMemberModal: FC<AddTeamMemberModalProps> = (
    props: AddTeamMemberModalProps
) => {
    const { formikRef, FormikStateBridge } =
        useFormikStateSync<Partial<RPUser>>()

    const handleSubmit = async (values: Partial<RPUser>) => {
        await props.onSubmit(values as NewRPUser)
        props.onClose()
    }

    return (
        <Dialog
            open={props.open}
            onClose={props.onClose}
            title="Add Team Member"
            content={
                <ProfileDetailsForm
                    formikRef={formikRef}
                    FormikStateBridge={FormikStateBridge}
                    activeUser={props.activeUser}
                    targetUser={{} as RPUser} // Empty object as placeholder
                    onSubmit={handleSubmit}
                    mode={ProfileFormMode.ADD_MEMBER}
                />
            }
            ctas={[
                <Button
                    color="secondary"
                    variant="outlined"
                    key="cancel"
                    type="reset"
                    onClick={props.onClose}
                >
                    Cancel
                </Button>,
                <LoadingButton
                    color="primary"
                    variant="contained"
                    disabled={!formikRef.current?.isValid}
                    key="send-invite"
                    onClickAsync={async () =>
                        await formikRef.current?.submitForm?.()
                    }
                >
                    Send Invite
                </LoadingButton>,
            ]}
        />
    )
}
